import { collection, doc, setDoc, getDoc, updateDoc, getDocs } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { COLLECTIONS } from './schema';

export interface UserPlan {
  planId: string;
  videosRemaining: number;
  totalVideos: number;
  purchasedAt: Date;
}

export const FREE_PLAN: UserPlan = {
  planId: 'free',
  videosRemaining: 1,
  totalVideos: 1,
  purchasedAt: new Date()
};

export const assignFreePlan = async (userId: string): Promise<void> => {
  const userRef = doc(db, COLLECTIONS.USERS, userId);
  const userDoc = await getDoc(userRef);

  if (userDoc.exists()) {
    const userData = userDoc.data();
    // Only assign free plan if user doesn't have any plan
    if (!userData.plan) {
      console.log(`Assigning free plan to user ${userId}`);
      await updateDoc(userRef, {
        plan: FREE_PLAN
      });
      console.log(`Successfully assigned free plan to user ${userId}`);
    }
  }
};

export const assignDefaultPlanToUsers = async (): Promise<void> => {
  console.log('Starting to assign default plans to users...');
  const usersRef = collection(db, COLLECTIONS.USERS);
  const usersSnapshot = await getDocs(usersRef);
  
  const batch = [];
  let assignedCount = 0;
  
  for (const userDoc of usersSnapshot.docs) {
    const userData = userDoc.data();
    if (!userData.plan) {
      console.log(`Assigning plan to user: ${userDoc.id}`);
      batch.push(
        updateDoc(userDoc.ref, {
          plan: {
            ...FREE_PLAN,
            purchasedAt: new Date()
          }
        })
      );
      assignedCount++;
    }
  }

  if (batch.length > 0) {
    await Promise.all(batch);
    console.log(`Successfully assigned ${assignedCount} free plans`);
  } else {
    console.log('No users needed plan assignment');
  }
};

export const decrementVideosRemaining = async (userId: string): Promise<void> => {
  const userRef = doc(db, COLLECTIONS.USERS, userId);
  const userDoc = await getDoc(userRef);

  if (userDoc.exists()) {
    const userData = userDoc.data();
    if (userData.plan && userData.plan.videosRemaining > 0) {
      await updateDoc(userRef, {
        'plan.videosRemaining': userData.plan.videosRemaining - 1
      });
    }
  }
};